(function () {
    'use strict';

    angular.module('doclr.keycloak')
        .factory('keycloakInterceptor', function ($q) {
            return {
                request: function (config) {
                    let deferred = $q.defer();
                    let token = window.keycloakServiceInstance.getToken();
                    if (token) {
                        window.keycloakServiceInstance.updateToken()
                            .then(() => {
                                let possibleToken = window.keycloakServiceInstance.getToken();
                                if (possibleToken) {
                                    config.headers = config.headers || {};
                                    config.headers['Authorization'] = 'Bearer ' + possibleToken;
                                    deferred.resolve(config);
                                }
                            }).catch(() => {
                        });
                    } else {
                        window.keycloakServiceInstance.retryLogin();
                    }

                    return deferred.promise;
                },
            };

        })
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push('keycloakInterceptor');
        });

})();